
import { useSelector } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import styled from "styled-components"

import garajYogunluk from "../../../images/svg/kamyon-yogunluk.svg"
import garajYogunlukLight from "../../../images/svg/kamyonGarajLight.svg"
import { useDispatch } from "react-redux"
import { setMobileMenuOpenedParentPath } from "../../../features/layout/layoutSlice"
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import ai from "../../../images/svg/ai/ai-mobile-menu.svg"
import { MdLogout } from "react-icons/md";
import { IoLogOutOutline } from "react-icons/io5";
import logoutIcon from "../../../images/svg/logout-icon.svg"
import { logoutUser } from "../../../features/auth/authSlice"
import { showedMenusIcons } from "../../../utils/navItems/showedMenus"
const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px; 
    justify-content: space-between;
    width: 100%;
    border-radius: 10px;
    color: ${({theme}) => theme.mainTextColor};
    margin-top: 20px;

    .menu-item{
        flex-grow: 1; /* Elemanların yatay olarak genişlemesini sağlar */
        flex-basis: calc(33.333% - 20px); /* 3 eleman sığdırmak için dinamik genişlik */
        height: 200px; /* Yükseklik sabit olabilir, isteğe bağlı olarak responsive yapılabilir */
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        padding: 15px;

        .menu-icon{
            width: 40px;
            color: ${(theme) => theme.mainTextColor};
        }

        .menu-name{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            text-align: center;
            color: ${(theme) => theme.mainTextColor};

        }

        .logout-icon{
            font-size: 2.4rem;
            color: ${(theme) => theme.mainTextColor};
        }
    }

    .menu-item-ai{
        padding: 15px 0 !important;

    }

    .active-menu-item{
        border-color: ${({theme}) => theme.mainTextColor};
        border-color: var(--color-main);
    }


    .sub-menu-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .back-container{
            width: 100%;
            /* background-color: ${({theme}) => theme.secondaryBgColor}; */
            padding: 10px;
            border-radius: 10px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            gap: 30px;

            .back-icon{
                font-size: 1.6rem;
            }

            .text{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }

        }

        .active-sub-menu-item{
            width: 100%;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            padding: 35px 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-bottom: 20px;

            .active-menu-icon{
                width: 50px;
            }

            .active-menu-name{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                text-align: center;
            }

        }

        .sub-menu-list{
            display: flex;
            flex-direction: column;
            gap: 20px;
            width: 100%;

            .sub-menu-item{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                padding: 10px 25px;
                width: 100%;
                background-color: ${({theme}) => theme.secondaryBgColor};
                border-radius: 5px;


            }

        }


    }

  @media (max-width: 750px) {

    .menu-item{
        flex-basis: calc(50% - 20px); /* 3 eleman sığdırmak için dinamik genişlik */

    }

    .menu-item-ai{
        flex-basis: 100% !important; /* 3 eleman sığdırmak için dinamik genişlik */

    }

  }
`

const NavbarMobile = () => {
    const {
        navItemsFromMainLayout,
        subLinksFromMainLayout,
        mobileMenuOpenedParentPath,
        theme
    } = useSelector(state => state.layout)

  const location = useLocation().pathname;
  const dispatch = useDispatch()
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
  return (
    <Container>
        {
            (!mobileMenuOpenedParentPath || mobileMenuOpenedParentPath?.permission?.length < 2 ) &&
            navItemsFromMainLayout?.map(item => {
                if(item.permission.length !== 1){
                    return (
                        <div onClick={() => dispatch(setMobileMenuOpenedParentPath(item))} className={item.permission[0].slug.split("/")[1] === location.split("/")[1] ? "active-menu-item menu-item" :"menu-item"}>
                            <div className="menu-icon">{showedMenusIcons.find(it => it.text === item.permission[0].slug.split("/")[1])?.iconLarge}</div>
                            <div className="menu-name">{item.name}</div>
                        </div>
                    )
                }
                else{
                    return(
                        <Link to={item.permission[0].slug} onClick={() => dispatch(setMobileMenuOpenedParentPath(item))} className={item.permission[0].slug.split("/")[1] === location.split("/")[1] ? "active-menu-item menu-item" :"menu-item"}>
                            <div className="menu-icon">{showedMenusIcons.find(it => it.text === item.permission[0].slug.split("/")[1])?.iconLarge}</div>
                            <div className="menu-name">{item.name}</div>
                        </Link>
                    )
                }
            })
        }
                {/* {   
            !mobileMenuOpenedParentPath?.parentPath &&
            <Link to={"/akilli-kamyoon"}  className={"akilli-kamyoon" === location.split("/")[1] ? "active-menu-item menu-item menu-item-ai" :"menu-item menu-item-ai"}>
                <img className="menu-icon" src={ theme === "dark" ? ai : ai} style={{width: "100%"}} alt="" />
                <div className="menu-name">Yapay Zeka</div>
            </Link>
        } */}
        {
            ((!mobileMenuOpenedParentPath || mobileMenuOpenedParentPath?.permission?.length < 2 ) && (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) &&
            <Link to={"/kamyon-garaj-yogunluklari"}  className={"kamyon-garaj-yogunluklari" === location.split("/")[1] ? "active-menu-item menu-item" :"menu-item"}>
                <img className="menu-icon" src={ theme === "dark" ? garajYogunlukLight : garajYogunluk} alt="" />
                <div className="menu-name">kamyon Garajları Yoğunluğu</div>
            </Link>
        }
        {
            (!mobileMenuOpenedParentPath || mobileMenuOpenedParentPath?.permission?.length < 2 ) &&
            <button className={"menu-item"} onClick={() => dispatch(logoutUser())}>
                <img  className="menu-icon" src={logoutIcon} alt="" />
                <div className="menu-name">Çıkış</div>
            </button>
        }
    




        {
            mobileMenuOpenedParentPath?.permission?.length > 1 &&           
            <div className="sub-menu-container">
                <div className="back-container" onClick={() => dispatch(setMobileMenuOpenedParentPath(null))}>
                    <MdOutlineArrowBackIosNew className="back-icon"/>
                    <div className="text">{mobileMenuOpenedParentPath.text}</div>
                </div>

                <div className="sub-menu-list">
                    {
                        mobileMenuOpenedParentPath.permission.map(item =>(
                            <Link to={item.slug} className="sub-menu-item">
                                {item.description}
                            </Link>
                        ))
                    }
                </div>
            </div>
        }

    </Container>
  )
}

export default NavbarMobile